<template>
    <div class="animated fadeIn">
        <splash-hero></splash-hero>
        <div v-if="!isMobile() && isPersian(currentLocale)">
            <customers></customers>
        </div>
        <world-coverage></world-coverage>
        <affordable></affordable>
        <connect-everywhere></connect-everywhere>
        <admin-dashboard></admin-dashboard>
        <Unlimited></Unlimited>
        <security></security>
        <download-app></download-app>
        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">

</style>

<script>
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go";
    import DownloadApp from "@/components/download-app/download-app";
    import SplashHero from "./components/splash-hero/splash-hero";
    import ConnectEverywhere from "./components/connect-everywhere/connect-everywhere";
    import AdminDashboard from "./components/admin-dashboard/admin-dashboard";
    import WorldCoverage from "./components/world-coverage/world-coverage";
    import Affordable from "./components/affordable/affordable";
    import Unlimited from "./components/unlimited/unlimited";
    import Security from "./components/security/security";
    import Customers from "./components/customers/customers";

    export default {
        components: {
            Customers,
            SplashHero,
            ConnectEverywhere,
            AdminDashboard,
            DownloadApp,
            PayAsYouGo,
            WorldCoverage,
            Affordable,
            Unlimited,
            Security,
        },

        data() {
            return {
                currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
            };
        },

        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },

            isPersian(locale) {
                return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
            }
        }
    }
</script>
